import './index-d4808923.js';

const defaultOptions = {
    elementDelimiter: "__",
    modifierDelimiter: "--",
    namespace: "",
    namespaceDelimiter: "-",
    strict: true,
};
/**
 * Set up the default options.
 *
 * @param options - Options to control a generated class name.
 */
function setup({ elementDelimiter, modifierDelimiter, namespace, namespaceDelimiter, strict, }) {
    if (typeof elementDelimiter === "string") {
        defaultOptions.elementDelimiter = elementDelimiter;
    }
    if (typeof modifierDelimiter === "string") {
        defaultOptions.modifierDelimiter = modifierDelimiter;
    }
    if (typeof namespace === "string" || Array.isArray(namespace)) {
        defaultOptions.namespace = namespace;
    }
    if (typeof namespaceDelimiter === "string") {
        defaultOptions.namespaceDelimiter = namespaceDelimiter;
    }
    if (typeof strict === "boolean") {
        defaultOptions.strict = strict;
    }
}
const uniqueChars = (list) => list
    .join("")
    .split("")
    .filter((value, index, self) => self.indexOf(value) === index);
const includesChars = (str, chars) => chars.some((char) => str.includes(char));
const invalidMessage = (subject, subjectValue, delimiters) => {
    const delims = `"${delimiters.join('", "')}"`;
    return `The ${subject} ("${subjectValue}") must not use the characters contained within the delimiters (${delims}).`;
};
/**
 * Creates a function to generate a BEM class name.
 *
 * @param block - A BEM block name.
 * @param options - Options to control a generated class name.
 * @returns A function to generate a BEM class name.
 */
function bem$1(block, options = {}) {
    const { elementDelimiter, modifierDelimiter, namespace, namespaceDelimiter, strict } = {
        ...defaultOptions,
        ...options,
    };
    const namespaces = []
        .concat(namespace)
        .filter(Boolean) // compact
        .reduce((joined, ns) => `${joined}${ns}${namespaceDelimiter}`, "");
    const namespaceBlock = `${namespaces}${block}`;
    const delimiters = strict ? [namespaceDelimiter, elementDelimiter, modifierDelimiter] : [];
    const delimiterChars = strict ? uniqueChars(delimiters) : [];
    return function bemBlock(elementOrModifiers, modifiers) {
        if (elementOrModifiers == null) {
            return namespaceBlock;
        }
        const element = typeof elementOrModifiers === "string" ? elementOrModifiers : null;
        if (strict && element != null && includesChars(element, delimiterChars)) {
            throw new Error(invalidMessage("element", element, delimiters));
        }
        const base = element == null ? namespaceBlock : `${namespaceBlock}${elementDelimiter}${element}`;
        const mods = typeof elementOrModifiers === "string" ? modifiers : elementOrModifiers;
        if (mods == null) {
            return base;
        }
        const addModifiers = (className, modifier) => {
            if (modifier != null && modifier !== "") {
                if (strict && includesChars(modifier, delimiterChars)) {
                    throw new Error(invalidMessage("modifier", modifier, delimiters));
                }
                return `${className} ${base}${modifierDelimiter}${modifier}`;
            }
            return className;
        };
        if (Array.isArray(mods)) {
            return mods.reduce(addModifiers, base);
        }
        return Object.keys(mods)
            .filter((mod) => mods[mod])
            .reduce(addModifiers, base);
    };
}

setup({
    strict: false,
});
const transformModifierToArray = (modifiers) => {
    if (typeof modifiers !== 'object') {
        return modifiers;
    }
    return Object.keys(modifiers).reduce((acc, key) => {
        const value = modifiers[key];
        if (!value) {
            return acc;
        }
        if (value === true) {
            return [...acc, key];
        }
        /* if an object is passed we assume that we want to create responsive classes
         * e.g. the current key being "layout" and this passed as value:
         * { small: "compact", medium: "normal" }
         * we want to create the classes $BLOCK--layout-compact@small and $BLOCK--layout-normal@medium
         */
        if (typeof value === 'object') {
            const generatedResponsiveClasses = Object.keys(value).map((breakpoint) => {
                return `${key}-${value[breakpoint]}@${breakpoint}`;
            });
            return [...acc, ...generatedResponsiveClasses];
        }
        return [...acc, `${key}-${value}`];
    }, []);
};
const bem = (block) => {
    return (elementOrModifiers, modifiers) => {
        const element = typeof elementOrModifiers === 'string' ? elementOrModifiers : transformModifierToArray(elementOrModifiers);
        return bem$1(block)(element, transformModifierToArray(modifiers));
    };
};

// eslint-disable-next-line no-restricted-globals
const global$1 = typeof window === 'undefined' ? {} : window;

// FIXME: temporary solution to support both libraries without context
// alternative solutions: rename to more generic "dsConfig" or make it context aware
let disableWarnings = !!global$1.cosmosConfig?.disableWarnings || !!global$1.gravityConfig?.disableWarnings;
/**
 * Global config
 * @typedef {Object} Config
 * @property {boolean} disableWarnings - Flag to disable console warnings
 */
const config = {
    get disableWarnings() {
        return disableWarnings;
    },
    set disableWarnings(value) {
        disableWarnings = value;
    },
};
// Makes the config available
global$1.cosmosConfig = config;
global$1.gravityConfig = config;

/**
 * Wait for next tick
 * It is necessary to call requestAnimationFrame twice to ensure we are at the next repaint
 * https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame
 *
 * @return Promise<void>
 */
const nextTick = () => new Promise((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(() => {
        resolve();
    }));
});

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

/** Detect free variable `global` from Node.js. */
var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
freeGlobal$1 || freeSelf$1 || Function('return this')();

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
freeGlobal || freeSelf || Function('return this')();

const isNodeEnvironment = () => {
    return typeof process !== 'undefined' && process.versions != null && process.versions.node != null;
};

const getInitials = (name) => {
    if (!name) {
        return '';
    }
    const nameParts = name.trim().split(/\s+/); // split on whitespace
    const initials = nameParts
        .filter((_, index, array) => index === 0 || index === array.length - 1) // keep first and last name
        .filter((part) => !part.endsWith('.')) // remove trailing dots
        .map((part) => part.replace(/[^\S]/g, '')) // remove non alphanumeric characters
        .map((part) => part.charAt(0).toUpperCase())
        .join('');
    return initials;
};

/**
 * Checks if a given host element has a default (unnamed) slot.
 *
 * @param host - The host element to check.
 * @returns `true` if the default slot exists, `false` otherwise.
 */
function hasDefaultSlot(host) {
    return [...host.childNodes].some((node) => {
        if (node.nodeType === Node.TEXT_NODE && node?.textContent?.trim() !== '') {
            return true;
        }
        if (node.nodeType === Node.ELEMENT_NODE) {
            const el = node;
            // If it doesn't have a slot attribute, it's part of the default slot
            if (!el.hasAttribute('slot')) {
                return true;
            }
        }
        return false;
    });
}
/**
 * Checks if a given host element has a named slot.
 *
 * @param host - The host element to check.
 * @param slotName - The name of the slot to check for.
 * @returns `true` if the named slot exists, `false` otherwise.
 */
function hasNamedSlot(host, slotName) {
    if (!host || typeof host.querySelector !== 'function') {
        return false;
    }
    try {
        return host.querySelector(`:scope > [slot="${slotName}"]`) !== null;
    }
    catch (e) {
        return host.querySelector(`[slot="${slotName}"]`) !== null;
    }
}

/**
 * SlotMutationService observes and handles mutations in slotted content using MutationObserver.
 * It's particularly useful in environments where the 'slotchange' event is unreliable.
 *
 * @remarks
 * This service addresses specific issues with slot change detection:
 * - In Angular, unnamed slot changes are not detected via 'slotchange' events when using string interpolation with deferred slotted content.
 * - The 'slotchange' events are not triggered on initial load for prerendered content.
 *
 * @class
 */
class SlotMutationService {
    constructor() {
        this.observers = new Map();
        this.isNodeEnv = isNodeEnvironment();
        this.observer = this.isNodeEnv ? null : this.createObserver();
    }
    /**
     * Gets the singleton instance of SlotMutationService.
     *
     * @returns {SlotMutationService} The singleton instance of SlotMutationService.
     * @static
     */
    static getInstance() {
        if (!SlotMutationService.instance) {
            SlotMutationService.instance = new SlotMutationService();
        }
        return SlotMutationService.instance;
    }
    /**
     * Starts observing the given element for mutations.
     *
     * @remarks
     * It is recommended to call this method in the `componentWillLoad` lifecycle method
     * of a Stencil component to ensure that the element is observed as soon as it is loaded.
     *
     * @param {HTMLElement} element - The element to observe.
     * @param {() => void} handleSlotChange - The callback to execute when a mutation is observed.
     * @returns {void}
     */
    observe(element, handleSlotChange) {
        if (this.isNodeEnv || this.observers.has(element))
            return;
        this.observers.set(element, handleSlotChange);
        this.observer?.observe(element, SlotMutationService.OBSERVER_OPTIONS);
        handleSlotChange.call(element);
    }
    /**
     * Stops observing the given element for mutations.
     *
     * @remarks
     * It is recommended to call this method in the `disconnectedCallback` lifecycle method
     * of a Stencil component to ensure that the element is no longer observed when it is removed from the DOM.
     *
     * @param {HTMLElement} element - The element to stop observing.
     * @returns {void}
     */
    unobserve(element) {
        if (this.isNodeEnv || !this.observers.has(element))
            return;
        this.observers.delete(element);
        if (this.observers.size === 0) {
            this.observer?.disconnect();
        }
    }
    /**
     * Creates a MutationObserver instance.
     *
     * @returns {MutationObserver} The created MutationObserver instance.
     * @private
     */
    createObserver() {
        return new MutationObserver(this.handleMutations.bind(this));
    }
    /**
     * Handles observed mutations.
     *
     * @param {MutationRecord[]} mutations - The array of observed mutations.
     * @returns {void}
     * @private
     */
    handleMutations(mutations) {
        mutations.forEach((mutation) => {
            this.observers.forEach((handleSlotChange, element) => {
                if (element.contains(mutation.target)) {
                    handleSlotChange.call(element);
                }
            });
        });
    }
}
SlotMutationService.instance = null;
SlotMutationService.OBSERVER_OPTIONS = {
    childList: true,
    subtree: true,
    characterData: true,
};
/**
 * Singleton instance of SlotMutationService.
 */
const slotMutationService = SlotMutationService.getInstance();

export { getInitials as a, bem as b, hasDefaultSlot as c, global$1 as g, hasNamedSlot as h, nextTick as n, slotMutationService as s };

//# sourceMappingURL=index.esm-7182addc.js.map